import abTesting from "../../../services/abTesting";
import AIAssistant from "./AIAssistant";
import AIAssistantV2 from "./v2/AIAssistantV2";
import { isMobile } from "../../../utilities/helpers";

const AIAssistantWrap = () => {
  if (abTesting.aiAssistantV2 && isMobile()) {
    return <AIAssistantV2 />;
  }

  if (abTesting.aiAssistant || (!isMobile() && abTesting.aiAssistantV2)) {
    return <AIAssistant />;
  }

  return null;
}

export default AIAssistantWrap;
